export default {
  'menu.welcome': 'Chào mừng',
  'menu.home': 'Trang chủ',
  'menu.login': 'Đăng nhập',
  'menu.register': 'Đăng ký',
  'menu.register-result': 'Kết quả đăng ký',
  'menu.dashboard': 'Bảng điều khiển',
  'menu.dashboard.analysis': 'Phân tích',
  'menu.dashboard.monitor': 'Giám sát',
  'menu.dashboard.workplace': 'Nơi làm việc',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.profile': 'Hồ sơ',
  'menu.profile.basic': 'Hồ sơ cơ bản',
  'menu.profile.advanced': 'Hồ sơ nâng cao',
  'menu.result': 'Kết quả',
  'menu.result.success': 'Thành công',
  'menu.result.fail': 'Thất bại',
  'menu.exception': 'Lỗi hệ thống',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Gây lỗi',
  'menu.account': 'Tài khoản',
  'menu.account.center': 'Trung tâm tài khoản',
  'menu.account.settings': 'Cài đặt tài khoản',
  'menu.account.trigger': 'Kích hoạt lỗi',
  'menu.account.logout': 'Đăng xuất',
  'menu.editor': 'Trình chỉnh sửa đồ họa',
  'menu.editor.flow': 'Trình chỉnh sửa Flow',
  'menu.editor.mind': 'Trình chỉnh sửa Mind',
  'menu.editor.koni': 'Trình chỉnh sửa Koni',

  // Master Data Group
  'menu.masterData': 'Dữ liệu cơ sở',
  'menu.masterData.brand': 'Thương hiệu',
  'menu.masterData.color': 'Màu sắc',
  'menu.masterData.currency': 'Tiền tệ',
  'menu.masterData.origin': 'Xuất xứ',
  'menu.masterData.size': 'Kích thước',
  'menu.masterData.knitStructure': 'Cấu trúc dệt kim',
  'menu.masterData.gauge': 'Gauge',
  'menu.masterData.needleType': 'Loại kim',
  'menu.masterData.patternType': 'Loại hoa văn',
  'menu.masterData.camType': 'Loại cam',
  'menu.masterData.machineDiameter': 'Đường kính máy',
  'menu.masterData.uom': 'Đơn vị đo',
  'menu.masterData.site': 'Kho',
  'menu.masterData.accountGroup': 'Nhóm tài khoản',
  'menu.masterData.jobPosition': 'Chức danh',

  // Organization Group
  'menu.organization': 'Tổ chức',
  'menu.organization.organization': 'Tổ chức',
  'menu.organization.organizationDetail': 'Chi tiết tổ chức',
  'menu.organization.address': 'Địa chỉ',
  'menu.organization.addressDetail': 'Chi tiết địa chỉ',

  // Production Group
  'menu.production': 'Sản xuất',
  'menu.production.line': 'Dây chuyền',
  'menu.production.lineType': 'Loại dây chuyền',
  'menu.production.machine': 'Máy móc',
  'menu.production.machineType': 'Loại máy móc',
  'menu.production.operationLibrary': 'Thư viện công đoạn',
  'menu.production.operationLibraryDetail': 'Chi tiết thư viện công đoạn',
  'menu.production.componentGroup': 'Nhóm thành phần',
  'menu.production.component': 'Thành phần',

  // Business Partners Group
  'menu.businessPartners': 'Đối tác kinh doanh',
  'menu.businessPartners.customer': 'Khách hàng',
  'menu.businessPartners.customerType': 'Loại khách hàng',
  'menu.businessPartners.supplier': 'Nhà cung cấp',
  'menu.businessPartners.supplierType': 'Loại nhà cung cấp',

  // Product Management Group
  'menu.productManagement': 'Quản lý sản phẩm',
  'menu.productManagement.product': 'Sản phẩm',
  'menu.productManagement.productType': 'Loại sản phẩm',
  'menu.productManagement.category': 'Danh mục',
  'menu.productManagement.productGroup': 'Nhóm sản phẩm',
  'menu.productManagement.subCategory': 'Danh mục con',

  // Human Resources Group
  'menu.humanResources': 'Nhân sự',
  'menu.humanResources.employee': 'Nhân viên',
  'menu.humanResources.employeeType': 'Loại nhân viên',
  'menu.humanResources.calendar': 'Lịch làm việc',
  'menu.humanResources.calendarCustomize': 'Lịch tùy chỉnh',
  'menu.humanResources.holiday': 'Ngày lễ',

  // Shipping & Logistics Group
  'menu.shippingLogistics': 'Vận chuyển & Logistics',
  'menu.shippingLogistics.port': 'Cảng',
  'menu.shippingLogistics.deliveryTerm': 'Điều khoản giao hàng',
  'menu.shippingLogistics.shipmentTerm': 'Điều khoản vận chuyển',
  'menu.shippingLogistics.paymentTerm': 'Điều khoản thanh toán',

  // IE Analysis Group
  'menu.ieAnalysis': 'Phân tích IE',
  'menu.ieAnalysis.ierequest': 'Yêu cầu phân tích',
  'menu.ieAnalysis.ierequestdetail': 'Chi tiết yêu cầu phân tích',
  'menu.ieAnalysis.labdiprequest': 'Lab Dip Request',
  'menu.ieAnalysis.labdiprequestdetail': 'Chi tiết Lab Dip Request',

  // Knit Analysis Group
  'menu.knitAnalysis': 'Phân tích dệt kim',
  'menu.knitAnalysis.knitanalysis': 'Phân tích dệt kim',
  'menu.knitAnalysis.knitanalysisdetail': 'Chi tiết phân tích dệt kim',

  // Woven Analysis Group
  'menu.wovenAnalysis': 'Phân tích Woven',
  'menu.wovenAnalysis.wovenrequest': 'Woven Request',
  'menu.wovenAnalysis.wovenrequestdetail': 'Chi tiết Woven Request',

  // Dyeing Analysis Group
  'menu.dyeingAnalysis': 'Phân tích Dyeing',
  'menu.dyeingAnalysis.dyeingrequest': 'Dyeing Request',
  'menu.dyeingAnalysis.dyeingrequestdetail': 'Chi tiết Dyeing Request',
  'menu.dyeingAnalysis.recipe': 'Recipe Library',
  'menu.dyeingAnalysis.recipedetail': 'Chi tiết Recipe',
  'menu.dyeingAnalysis.beakertest': 'Beaker Test List',
  'menu.dyeingAnalysis.beakertestdetail': 'Beaker Test Detail',

  // Legacy menu items (keeping for backward compatibility)
  'menu.list': 'Danh mục (Cũ)',
  'menu.list.organization': 'Tổ chức',
  'menu.list.organizationDetail': 'Tổ chức',
  'menu.list.operationLibraryDetail': 'Thư viện công đoạn',
  'menu.list.addressDetail': 'Địa chỉ',
  'menu.list.accountGroup': 'Nhóm tài khoản',
  'menu.list.jobPosition': 'Chức danh',
  'menu.list.color': 'Màu sắc',
  'menu.list.currency': 'Tiền tệ',
  'menu.list.customer': 'Khách hàng',
  'menu.list.customerType': 'Loại khách hàng',
  'menu.list.address': 'Địa chỉ',
  'menu.list.calendarCustomize': 'Lịch tùy chỉnh',
  'menu.list.calendar': 'Lịch làm việc',
  'menu.list.brand': 'Thương hiệu',
  'menu.list.deliveryTerm': 'Điều khoản giao hàng',
  'menu.list.employee': 'Nhân viên',
  'menu.list.costCategory': 'Loại khoản mục',
  'menu.list.costItem': 'Khoản mục chi phí',

  'menu.business': 'Nghiệp vụ',
  'menu.business.plan': 'Kế hoạch ngân sách',
  'menu.business.costRequest': 'Yêu cầu chi phí',

  'menu.reports': 'Báo cáo',
  'menu.reports.organization': 'Theo Tổ chức',
  'menu.reports.costItem': 'Theo Khoản mục chi phí',
  'menu.reports.summary': 'Tổng hợp',
  'menu.admin': 'Quản trị',
};
